import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'
import flowersLeft from 'resources/svg/white-flowers-l.svg'
import flowersRight from 'resources/svg/white-flowers-r.svg'

export const Title = styled.h1`
  ${props => props.theme.css.heading1}
  margin: 0 0 30px;
`

export const PublicLayout = styled.div`
  padding: 100px 20px;
  background: ${props => props.theme.palette.primary.alpha};
  ${bp('sm')`
    padding: 40px 20px 60px;
  `}

  > div {
    max-width: 400px;
    margin: 0 auto;
    background: ${props => props.theme.palette.general.light};
    padding: 20px;
    border-radius: 10px;
    position: relative;
    z-index: 1;

    &::before {
      width: 500px;
      height: 350px;
      background: url(${flowersLeft}) no-repeat center;
      left: -70%;
      top: 0;
    }

    &::after {
      width: 450px;
      height: 530px;
      background: url(${flowersRight}) no-repeat center;
      right: -70%;
      bottom: 0;
    }

    &::before,
    &::after {
      content: '';
      position: absolute;
      background-size: contain;
      z-index: -1;
      ${bp('sm')`
        content: unset;
      `}
    }
  }

  form {
    button {
      margin: auto;
    }

    .bottom__checkbox {
      input {
        margin-right: 5px;
      }
    }
  }
`
